import { HttpClient } from '@angular/common/http';
import { ID } from '@state/base';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export interface ImpersonateResponse {
  jwt: string,
  redirect_url: string
}
@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  constructor(private http: HttpClient) {}

  impersonate$(userId: ID, vehicleId: ID): Observable<ImpersonateResponse> {
    let url = `${environment.apiUrl}/v1/impersonation`;

    return this.http.post<ImpersonateResponse>(url, {
      user_id: userId,
      vehicle_id: vehicleId
    });
  }
}
